import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import GeneralAuthentication from "../general/GeneralAuthentication";
import { useDispatch } from "react-redux";
import MainPane from "../general/MainPane";
import MainArea from "../ViewCompareComp/MainArea";
import { storeProspectidForCompareView } from "../store/compareview";

const ViewCompareForPDF = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(window.location.search);

  const prospectid = queryParams.get("token");

  dispatch(storeProspectidForCompareView(prospectid));

  return (
    <MainPane>
      <MainArea isProspectIdEncrypted={true}></MainArea>
    </MainPane>
  );
};

export default ViewCompareForPDF;
